import { DisctionaryContent } from "src/app/services/sitecoreDictionary/dictionary-content.service";
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Component, ElementRef, inject, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatChipInputEvent, MatChipGrid, MatChipRow, MatChipRemove, MatChipInput } from '@angular/material/chips';
import { MatDialog, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { map, Observable, startWith, Subject, takeUntil } from 'rxjs';
import { ApiResponse, CamDeleteModel } from 'src/app/models/interface/CAM/baseResponseInterfaces';
import { Branch } from 'src/app/models/interface/CAM/CompanyProfileInterface';
import { EmployeeGradeRequest, Grade } from 'src/app/models/interface/CAM/TravellerInterface';
import { CamService } from 'src/app/services/camService/cam.service';
import { CryptoService } from 'src/app/services/commonService/crypto.service';
import { CompanyManagementService } from 'src/app/services/dataLayer/CAM/company-management.service';
import { CommonService } from 'src/app/shared/common/common.service';
import { ToastrApiService } from 'src/app/shared/common/toastr-api.service';
import { CompanyManagementContentService } from '../../services/company-management-content.service';
import { NgIf, NgFor, NgClass, AsyncPipe } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatFormField, MatLabel, MatError, MatSuffix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatAutocompleteTrigger, MatAutocomplete, MatOption } from '@angular/material/autocomplete';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { MatButton } from '@angular/material/button';
import { MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { CamEmptyStateComponent } from '../cam-empty-state/cam-empty-state.component';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { BookingContentService } from "src/app/services/bookingContentService/booking-content.service";

@Component({
    selector: 'app-employeegrade',
    templateUrl: './employeegrade.component.html',
    styleUrls: ['./employeegrade.component.scss'],
    imports: [ReactiveFormsModule, NgIf, MatIcon, MatFormField, MatLabel, MatInput, MatError, MatChipGrid, NgFor, MatChipRow, MatChipRemove, MatChipInput, MatAutocompleteTrigger, MatSuffix, MatAutocomplete, MatOption, MatCheckbox, MatRadioGroup, MatRadioButton, MatButton, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, NgClass, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, CamEmptyStateComponent, CdkScrollable, MatDialogContent, MatDialogActions, AsyncPipe]
})
export class EmployeegradeComponent implements OnInit, OnDestroy {
  dictionaryContentData: any = null;
    manageCompanyContent: any;
  displayedColumns: string[] = ['Category Name', 'Category Code', 'Status', 'Actions'];
  Addnew: boolean = false;
  employeeGradeForm!: FormGroup;
  associateWithBranchArray: string[] = [];
  SA_UserId: any;
  isLoading = true;
  commonObjPipes: any = {
    GetAllDetails: { pipe: [] as Grade[], all: [] as Grade[] },
    GetAssociatedWithBranchId: { pipe: [] as Branch[], all: [] as Branch[] },
  }
  @ViewChild('selectionWarning') selectionWarning!: TemplateRef<any>;
  currentItem: any;
  //Chips Dropdown
  separatorKeysCodes: number[] = [ENTER, COMMA];
  associatedWithBranch = new FormControl('');
  filteredBranch: Observable<any[]>;
  branchName: string[] = [];
  selectedBranchIdsMap: { [key: number]: boolean } = {};
  @ViewChild('fruitInput') fruitInput!: ElementRef<HTMLInputElement>;
  announcer = inject(LiveAnnouncer);
  noRecordFound: boolean = false;
  content:any;
  dictionaryContent:any;
  private destroy$ = new Subject<void>();
  constructor(private readonly bookingContentService: BookingContentService, private _camService: CamService, private fb: FormBuilder, private crypto: CryptoService, private dialog: MatDialog, private _ToastrApiService: ToastrApiService, private _CommonService: CommonService, private _CompanyManagementService:CompanyManagementService,private contentService:CompanyManagementContentService,private readonly dictionaryContentService:DisctionaryContent, private _dictionaryContentService: DisctionaryContent) {
    this.employeeGradeForm = this.fb.group({
      flag: ['ADD'],
      employeeGradeId: [null],
      employeeGradeName: ['', [Validators.required, Validators.maxLength(100), Validators.minLength(2)]],
      employeeGradeCode: ['', [Validators.required, Validators.maxLength(30)]],
      associatedWithBranch: ['', [Validators.required]],
      sauserid: [this.crypto.getValueFromKey('USERID') as string],
      status: [true],
      isPersonal: [false],
      isBookForFamily: [false]
    })
    //  { validators: this.atLeastOneCheckboxValidator });

    this.filteredBranch = this.associatedWithBranch.valueChanges.pipe(
      startWith(null),
      map((value: string | null) => {
        if (typeof value === 'string') {
          return this._filter(value);
        } else {
          return this.commonObjPipes.GetAssociatedWithBranchId.pipe.slice();
        }
      })
    );
  }

  ngOnInit(): void {
    this._dictionaryContentService.content$.subscribe((res: any) => { if (res) { this.dictionaryContentData = res; } });
    this.contentService.content$.pipe(takeUntil(this.destroy$)).subscribe((res:any)=>{
      this.content = res;
    });
    this.dictionaryContentService.content$.pipe(takeUntil(this.destroy$)).subscribe((res:any)=>{
      this.dictionaryContent = res;
    })
    this.getEmployeeGradeDetails()
    this.loadInitialData()
    this.SA_UserId = this.crypto.getValueFromKey('USERID') as string;
      this.contentService.content$.subscribe((res: any) => { this.manageCompanyContent = res; });
  }

  handleEvent(event: string) {
    if (event.includes('employeegrade')) {
      this._CompanyManagementService.company_management_employeeGrade('Add link','Add',this.commonObjPipes.GetAllDetails.pipe.length)//GTM use
      this.Addnew = true;
    }
  }

  addNewEmployeeGrade() {
    this.Addnew = true;
    this.employeeGradeForm.reset({
      flag: 'ADD',
      employeeGradeId: null,
      status: true,
      isPersonal: false,
      isBookForFamily: false
    });

    this.selectedBranchIdsMap = {};
    this.branchName = [];

    this._CompanyManagementService.company_management_employeeGrade('Add link','Add',this.commonObjPipes.GetAllDetails.pipe.length)//GTM use
  }

  getEmployeeGradeDetails() {
    this._camService.getEmployeeGrade().then((res: ApiResponse<Grade[]>) => {
      if (res.status == "Success") {
        this.bindLists('GetAllDetails', res.data);
      }
    }).catch((error) => {
      this.bindLists('GetAllDetails', []);
      console.error(error)
    }).finally(() => {
      this.isLoading = false
    })
  }

  async loadInitialData() {
    try {
      const [branches] = await Promise.all([
        this._camService.GetBranchInformation(),
      ]);

      this.bindLists('GetAssociatedWithBranchId', branches.data);

    } catch (error: any) {
      const errMsg = error?.message || error?.error?.message || 'Something went wrong while fetching Data.';
      this._ToastrApiService.show('error', errMsg)
    }
  }

  bindLists(key: string, lists: any[]) {
    this.commonObjPipes[key].pipe = lists;
    this.commonObjPipes[key].all = lists;
  }

  onCheckboxBookFor(field: string, value: boolean) {
    this.employeeGradeForm.patchValue({
      [field]: value
    });
  }

  onCheckboxChange(event: any, branch: any, parentClass: string, matAutoClassRef: string) {
    this.selectedBranchIdsMap[branch.corpBranchId] = event.checked;
    if (event.checked) {
      if (!this.branchName.includes(branch.corpBranchName)) {
        this.branchName.push(branch.corpBranchName);
      }
    } else {
      this.branchName = this.branchName.filter(name => name.toLowerCase().trim() != branch.corpBranchName.toLowerCase().trim())
    }
    const selectedBranchId = Object.keys(this.selectedBranchIdsMap).filter(key => this.selectedBranchIdsMap[parseInt(key)])
    this.employeeGradeForm.controls['associatedWithBranch'].setValue(selectedBranchId.join(','));
    this.employeeGradeForm.controls['associatedWithBranch'].updateValueAndValidity();
    requestAnimationFrame(() => this.CustomMatAutoPosition(parentClass, matAutoClassRef));
  }

  CustomMatAutoPosition(parentClass: string, matAutoClassRef: string) {
    let parent = (document.querySelector(`.${parentClass}`) as HTMLDivElement).getBoundingClientRect();
    (document.querySelector('.cdk-overlay-connected-position-bounding-box .cdk-overlay-pane') as HTMLDivElement)?.style.setProperty('top', `${parent.top + parent.height}px`, 'important');
  }

  optionClicked(branch: any) {
    const newCheckedState = !this.selectedBranchIdsMap[branch.ID];
    const mockEvent = {
      checked: newCheckedState,
      stopPropagation: () => { } 
    };

    this.onCheckboxChange(mockEvent, branch, 'custom-mat-dropdown-parent', 'custom-autocomplete');
  };

  onSave() {
    this._CompanyManagementService.company_management_employeeGrade('Save button','Save',this.commonObjPipes.GetAllDetails.pipe.length)//GTM use
    this.employeeGradeForm.controls['sauserid'].setValue(this.SA_UserId);
    if (this.employeeGradeForm.invalid) {
      return
    }
    const requestData: EmployeeGradeRequest = {
      flag: this.employeeGradeForm.value.flag,
      employeeGradeId: this.employeeGradeForm.value.employeeGradeId,
      employeeGradeName: this.employeeGradeForm.value.employeeGradeName,
      employeeGradeCode: this.employeeGradeForm.value.employeeGradeCode,
      associatedWithBranch: this.employeeGradeForm.value.associatedWithBranch,
      sauserid: this.employeeGradeForm.value.sauserid,
      status: this.employeeGradeForm.value.status,
      isPersonal: true,
      isBookForFamily: true
    }    

    this._camService.insertUpdateEmployeeGradeV1(requestData).then((res) => {
      if (!res) {
        this._ToastrApiService.show('error', 'No response received from server.');
        return;
      }
      // Handle API response
      switch (res.status) {
        case 'Created':
          this._ToastrApiService.show('success', res.message || 'Employee grade created successfully.');
          this._CompanyManagementService.save_success('Employee grade', 'Success')//GTM use
          break;

        case 'Success':
          this._ToastrApiService.show('success', res.message || this.dictionaryContent?.['b2b.insertemployeegradedetails.200success'] || this.dictionaryContentData?.phrases?.b2b?.insertemployeegradedetails?.['200success'] || 'Employee grade updated successfully.');
          this._CompanyManagementService.save_success('Employee grade', 'Success')//GTM use
          break;

        case 'Conflict':
          this._ToastrApiService.show('warning', res.message || 'Employee grade entry detected.');
          break;

        default:
          this._ToastrApiService.show('error', res.message || 'Unexpected response from server.');
          console.warn('Unhandled status:', res);
          break;
      }

      this.getEmployeeGradeDetails();
      this.Addnew = false
      this._CommonService.formResetTrigger();// reset form triger

    }).catch((error) => {
      console.error(error)
      const errorMessage =
        error?.error?.message ||
        error?.message ||
        'Something went wrong while saving the department. Please try again later.';
        this._CompanyManagementService.view_error_message(errorMessage,error?.code);
      this._ToastrApiService.show('error', errorMessage);
    })
  }

  onEdit(item: Grade) {
    this._CompanyManagementService.company_management_employeeGrade('Edit button','Edit',this.commonObjPipes.GetAllDetails.pipe.length)//GTM use
    this.Addnew = true
    this.employeeGradeForm.reset(); 

    const associatedBranchIds = item.associatedWithBranchId
      ? item.associatedWithBranchId.split(',')
      : [];
    this.employeeGradeForm.patchValue({
      flag: 'UPDATE',
      employeeGradeId: item.categoryId,
      employeeGradeName: item.categoryName,
      employeeGradeCode: item.categoryCode,
      sauserid: item.corpCompanyId,
      status: item.status,
      isPersonal: !!item.isPersonal && typeof item.isPersonal === 'boolean' ? item.isPersonal : false,
      isBookForFamily: !!item.isBookForFamily,
      associatedWithBranch: associatedBranchIds.join(',')
    })

    this.selectedBranchIdsMap = {};
    this.branchName = [];

    associatedBranchIds.forEach((branchId: any) => {
      this.selectedBranchIdsMap[branchId] = true;
      const branch = this.commonObjPipes.GetAssociatedWithBranchId.pipe.find((b: { corpBranchId: any; }) => b.corpBranchId == branchId);
      if (branch) {
        this.branchName.push(branch.corpBranchName);
      }
    });

  }

  onRemove(item: Grade) {
    this.currentItem = item;
    this.dialog.open(this.selectionWarning, {
      data: item,
    });
    this._CompanyManagementService.company_management_employeeGrade('Remove button','Remove',this.commonObjPipes.GetAllDetails.pipe.length)//GTM use
    
  }

  confirmDelete(item: Grade) {

    const request: CamDeleteModel = {
      id: item.categoryId,
      type: 'EMPLOYEEGRADE'
    }

    this._camService.DeleteCAMitemBytype(request).then((res) => {
      this._ToastrApiService.show('success', res.message);
      if (res.status == "Success") {
        this.currentItem = undefined;
        this.getEmployeeGradeDetails()
        this._CompanyManagementService.grade_remove_Successfully('Removal','Success')// GTM use
      }
    }).catch((error)=>{
         const errorMessage =
        error?.error?.message ||
        error?.message ||
        'Something went wrong while delete the employee grade. Please try again later.';
        this._CompanyManagementService.view_error_message(errorMessage,error?.code);
      this._ToastrApiService.show('error', errorMessage);
    })
  }

  CloseDialog(result: boolean) {
    if (result) {
      this.confirmDelete(this.currentItem)
      this._CompanyManagementService.grade_remove('Proceed','Are you sure you want to remove this Employee grade?')//GTM use
    }
    if(!result){
      this._CompanyManagementService.grade_remove('Cancel','Are you sure you want to remove this Employee grade?')//GTM use

    }

    this.dialog.closeAll(); 
  }

  onCancel() {
    this.Addnew = false
    this._CommonService.formResetTrigger();
    this._CompanyManagementService.company_management_employeeGrade('Cancel button','Cancel',this.commonObjPipes.GetAllDetails.pipe.length)//GTM use

  }

  disableRightClick(event: MouseEvent): void {
    event.preventDefault();
  }

  onPasteBlocked(event: ClipboardEvent): void {
    event.preventDefault();
  }

  blockInvalidCharacters1(event: KeyboardEvent): void {
    const invalidChars = ['<', '>', '"', "'", '`', ';', ':', '$', '|', '[', ']', '~', '--', '@', '\\', '?', '+', '_', '#', '%', '^', '*', '!', '=', '%', '(', ')', '{', '}',];

    if (invalidChars.includes(event.key)) {
      event.preventDefault(); 
    }
  }

  // atLeastOneCheckboxValidator(control: AbstractControl): ValidationErrors | null {
  //   const isPersonal = control.get('isPersonal')?.value;
  //   const isBookForFamily = control.get('isBookForFamily')?.value;

  //   if (!isPersonal && !isBookForFamily) {
  //     return { atLeastOneCheckboxRequired: true };
  //   }
  //   return null; 
  // }

  add(event: MatChipInputEvent): void {

    const value = (event.value || '').trim();

    if (value) {
      const matchingBranch = this.commonObjPipes.GetAssociatedWithBranchId.pipe.find((branch: { corpBranchName: string; }) => branch.corpBranchName.toLowerCase() === value.toLowerCase());

      if (matchingBranch) {
        this.onCheckboxChange({ checked: true, stopPropagation: () => { } }, matchingBranch, 'custom-mat-dropdown-parent', 'custom-autocomplete');
      }
    }

    // Clear the input value
    event.chipInput!.clear();

    this.associatedWithBranch.setValue(null);
    let parent = (document.querySelector(`.${'custom-mat-dropdown-parent'}`) as HTMLDivElement).getBoundingClientRect();
    (document.querySelector(`.${'custom-autocomplete'}`) as HTMLDivElement).style.marginTop = `${parent.top + parent.height}px`;
  }

  remove(name: string): void {
    const index = this.branchName.indexOf(name);

    if (index >= 0) {
      this.branchName.splice(index, 1);
      const branch = this.commonObjPipes.GetAssociatedWithBranchId.pipe.find((branch: { corpBranchName: string; }) => branch.corpBranchName == name);

      if (branch) {
        this.selectedBranchIdsMap[branch.corpBranchId] = false;
        const selectedBranchId = Object.keys(this.selectedBranchIdsMap).filter(key => this.selectedBranchIdsMap[parseInt(key)]);
        this.employeeGradeForm.controls['associatedWithBranch'].setValue(selectedBranchId.join(','));
        this.employeeGradeForm.controls['associatedWithBranch'].updateValueAndValidity();
      }

      this.announcer.announce(`Removed ${name}`);
    }
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    const filteredData = this.commonObjPipes.GetAssociatedWithBranchId.pipe.filter((branch: { corpBranchName: string }) => branch.corpBranchName.toLowerCase().includes(filterValue));
    this.noRecordFound = filteredData.length == 0;
    return filteredData

  }
  ngOnDestroy(){
    this.destroy$.next();
    this.destroy$.complete();
  }
}

